/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsCirclePlusFill: {
  name: 'circle-plus-fill';
  data: string;
} = {
  name: 'circle-plus-fill',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm1 8a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1Z" fill="currentColor"/></svg>`,
};
